export const SDK_VERSION = '7.65.0';
